import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NodeHeader from '~/components/common/node-header';

/**
 * Lesson Grand child component for the workspace. It can contain quiz.
 *
 * @param {Object} props
 * @param {Object} props.node
 * @param {number} props.indexLesson
 * @param {number} props.index
 */
const LessonGrandchildWorkspace = ( { node, indexLesson, index } ) => (
	<Draggable
		draggableId={ JSON.stringify( { ...node } ) }
		index={ index }
		key={ node.ID }
	>
		{ ( provided ) => (
			<div
				key={ node.ID }
				ref={ provided.innerRef }
				{ ...provided.draggableProps }
				className={ classNames( {
					'ld__builder--grandchild-item': true,
				} ) }
			>
				<NodeHeader
					node={ node }
					provided={ provided }
					expanded={ true }
					className={ classNames( {
						'ld__builder-row-type': true,
						'-grand-child': true,
					} ) }
					indexLesson={ indexLesson }
					index={ index }
					toggleNode={ ( e ) => {
						e.preventDefault();
					} }
				/>
			</div>
		) }
	</Draggable>
);

/**
 * Valid props
 */
LessonGrandchildWorkspace.propTypes = {
	node: PropTypes.object,
	index: PropTypes.number,
	indexLesson: PropTypes.number,
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 */
const mapDispatchToProps = () => ( {} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( LessonGrandchildWorkspace );
